const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Canvas {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'canvasExt', name: '🖼️ キャンバス', color1: '#00BCD4', color2: '#0097A7',
            blocks: [
                { opcode: 'penSize', blockType: BlockType.COMMAND, text: 'ペンの太さを [S] にする', arguments: { S: { type: ArgumentType.NUMBER, defaultValue: 1 } } },
                { opcode: 'penColor', blockType: BlockType.COMMAND, text: 'ペンの色を [C] にする', arguments: { C: { type: ArgumentType.STRING, defaultValue: '#FF0000' } } },
                { opcode: 'drawLine', blockType: BlockType.COMMAND, text: '線 ([X1],[Y1])→([X2],[Y2])', arguments: { X1: { type: ArgumentType.NUMBER, defaultValue: -100 }, Y1: { type: ArgumentType.NUMBER, defaultValue: 0 }, X2: { type: ArgumentType.NUMBER, defaultValue: 100 }, Y2: { type: ArgumentType.NUMBER, defaultValue: 0 } } },
                { opcode: 'drawRect', blockType: BlockType.COMMAND, text: '四角 ([X],[Y]) [W]x[H]', arguments: { X: { type: ArgumentType.NUMBER, defaultValue: -50 }, Y: { type: ArgumentType.NUMBER, defaultValue: 50 }, W: { type: ArgumentType.NUMBER, defaultValue: 100 }, H: { type: ArgumentType.NUMBER, defaultValue: 100 } } },
                { opcode: 'drawCircle', blockType: BlockType.COMMAND, text: '円 ([X],[Y]) 半径 [R]', arguments: { X: { type: ArgumentType.NUMBER, defaultValue: 0 }, Y: { type: ArgumentType.NUMBER, defaultValue: 0 }, R: { type: ArgumentType.NUMBER, defaultValue: 50 } } },
                { opcode: 'clearCanvas', blockType: BlockType.COMMAND, text: 'キャンバスをクリア' }
            ]
        };
    }
    penSize(args) {}
    penColor(args) {}
    drawLine(args) {}
    drawRect(args) {}
    drawCircle(args) {}
    clearCanvas() { if (this.runtime) this.runtime.renderer.penClear(this.runtime.renderer.penSkinId); }
}
module.exports = Scratch3Canvas;